module.exports = __webpack_public_path__ + "img/logo@2x.ced7a88f.png";